import { Injectable } from '@angular/core';
import { User } from '../models/user.model';

@Injectable()
export class SessionHelper {
  private _userIdKey = 'userId';
  private _userKey = 'user';
  private _companyCodeKey = 'companyCode';
  private _companyNameKey = 'companyName';
  private _accessTokenKey = 'accessToken';
  private _accessTokenExpireInKey = 'AccessTokenExpireIn';
  private _refreshTokenKey = 'refreshToken';
  private _noFirstStepVideo = 'noFirstStepVideo';
  private _lastCompanySelectedDiasVacaciones = 'lastCompanySelectedDiasVacaciones';
  private _lastYearSelectedDiasVacaciones = 'lastYearSelectedDiasVacaciones';
  private _lastCompanySelectedBolsaVacaciones = 'lastCompanySelectedBolsaVacaciones';
  private _lastYearSelectedBolsaVacaciones = 'lastYearSelectedBolsaVacaciones';
  private _firsStepVideoShowed = 'firsStepVideoShowed';
  private _lastCompanySelectedGestionEmpleados = 'lastCompanySelectedGestionEmpleados';

  public SetSession(
    accessToken: string,
    refreshToken: string,
    companyCode: string,
    user: User
  ) {
    this.User = user;
    this.CompanyCode = companyCode;
    this.AccessToken = accessToken;
    this.RefreshToken = refreshToken;
  }

  public get UserId(): string {
    return sessionStorage.getItem(this._userIdKey);
  }
  public set UserId(userId: string) {
    sessionStorage.setItem(this._userIdKey, userId);
  }

  public get User(): User {
    return JSON.parse(sessionStorage.getItem(this._userKey));
  }
  public set User(user: User) {
    sessionStorage.setItem(this._userKey, JSON.stringify(user));
  }

  public get CompanyCode(): string {
    return sessionStorage.getItem(this._companyCodeKey);
  }
  public set CompanyCode(companyCode: string) {
    sessionStorage.setItem(this._companyCodeKey, companyCode);
  }

  public get CompanyName(): string {
    return sessionStorage.getItem(this._companyNameKey);
  }
  public set CompanyName(companyName: string) {
    sessionStorage.setItem(this._companyNameKey, companyName);
  }

  public get AccessToken(): string {
    return sessionStorage.getItem(this._accessTokenKey);
  }
  public set AccessToken(accessToken: string) {
    sessionStorage.setItem(this._accessTokenKey, accessToken);
  }

  public get AccessTokenExpireIn(): Date {
    return new Date(sessionStorage.getItem(this._accessTokenExpireInKey));
  }
  public set AccessTokenExpireIn(expireIn: Date) {
    sessionStorage.setItem(this._accessTokenExpireInKey, expireIn.toString());
  }
  public get RefreshToken(): string {
    return sessionStorage.getItem(this._refreshTokenKey);
  }
  public set RefreshToken(refreshToken: string) {
    sessionStorage.setItem(this._refreshTokenKey, refreshToken);
  }

  public get NotShowFirstStepVideoLS(): string[] {
    return JSON.parse(localStorage.getItem(this._noFirstStepVideo));
  }
  public set NotShowFirstStepVideoLS(notShowing: string[]) {
    localStorage.setItem(this._noFirstStepVideo, JSON.stringify(notShowing));
  }

  public get LastCompanySelectedDiasVacaciones(): number {
    return JSON.parse(sessionStorage.getItem(this._lastCompanySelectedDiasVacaciones));
  }
  public set LastCompanySelectedDiasVacaciones(companyCode: number) {
    sessionStorage.setItem(this._lastCompanySelectedDiasVacaciones, JSON.stringify(companyCode));
  }

  public get LastYearSelectedDiasVacaciones(): number {
    return JSON.parse(sessionStorage.getItem(this._lastYearSelectedDiasVacaciones));
  }
  public set LastYearSelectedDiasVacaciones(year: number) {
    sessionStorage.setItem(this._lastYearSelectedDiasVacaciones, JSON.stringify(year));
  }

  public get LastCompanySelectedBolsaVacaciones(): number {
    return JSON.parse(sessionStorage.getItem(this._lastCompanySelectedBolsaVacaciones));
  }
  public set LastCompanySelectedBolsaVacaciones(companyCode: number) {
    sessionStorage.setItem(this._lastCompanySelectedBolsaVacaciones, JSON.stringify(companyCode));
  }

  public get LastYearSelectedBolsaVacaciones(): number {
    return JSON.parse(sessionStorage.getItem(this._lastYearSelectedBolsaVacaciones));
  }
  public set LastYearSelectedBolsaVacaciones(year: number) {
    sessionStorage.setItem(this._lastYearSelectedBolsaVacaciones, JSON.stringify(year));
  }

  public get FirstStepVideoShowed(): boolean {
    return sessionStorage.getItem(this._firsStepVideoShowed) === 'true';
  }
  public set FirstStepVideoShowed(showed: boolean) {
    sessionStorage.setItem(this._firsStepVideoShowed, showed.toString());
  }

  public get LastCompanySelectedGestionEmpleados(): number {
    return JSON.parse(sessionStorage.getItem(this._lastCompanySelectedGestionEmpleados));
  }
  public set LastCompanySelectedGestionEmpleados(companyCode: number) {
    sessionStorage.setItem(this._lastCompanySelectedGestionEmpleados, JSON.stringify(companyCode));
  }

  // **************************************************//
  // Método que borra toda la información almacenada
  // **************************************************//
  public Delete() {
    sessionStorage.clear();
  }
}

